import { AssetId, ExperimentValue } from '../../../model'

export const getImageReservedSpaceClassName = (assetId: AssetId, variant?: ExperimentValue): string => {
  const variantSpecifier = variant ? `_${variant}` : ''
  return assetId + variantSpecifier
}
